<template>
    <div>
        <header-page
                @goToFilteredArticlePage="goToFilteredArticlePage"
        ></header-page>
        <div
                v-if="transformRubrics"
                class="body_zone p-t-16 p-b-150 p-r-20 p-l-20 separator-t-g2"
        >
            <div class="d-flex justify-content-center">
                <div class="col-md-10 col-lg-10 col-xl-8 col-xxl-8">
                    <div class="row">
                        <div
                                class="col-extra-6 col-sm-6 col-md-4 col-lg-4 p-b-6 p-t-6"
                                v-for="rubric in transformRubrics"
                                :key="rubric.id"
                        >
                            <router-link
                                    :to="`rubric?r=${rubric.id}`"
                                    custom v-slot="{ navigate }"
                            >
                                <div
                                        class="card h-100 style_cursor"
                                        @click="navigate"
                                >
                                    <div class="card-body style_cursor">
                                        <div class="d-flex justify-content-center m-t-16 m-b-16"><img :src="require(`@/assets/icons/${rubric.image_link}`)" height="56"></div>
                                        <div class="card-text text-center css_StyleText21">{{rubric.name}}</div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <footer-page />
    </div>
</template>

<script>
//import {watch} from "vue";
import {useRouter} from 'vue-router'
import HeaderPage from "../../shared/components/HeaderPage";
import FooterPage from "../../shared/components/FooterPage";
import {useRubricArticleStore} from "../../stores/store";
import {InitStates} from "../../shared/services/init";


export default {
    //props: { rubrics: { type: Object, required: true }},
    //emits: ['inFocus', 'submit'],
    setup(/*props, { emit }*/) {

        const router = useRouter();

        //console.log('HomePage');
        InitStates();
        const rubricArticleStore = useRubricArticleStore();
        //const { transformRubrics } = storeToRefs(rubricArticleStore);

        const goToFilteredArticlePage = (new_filter_text) => {
            router.push({name: 'filtered-articles', params: {filter_text: new_filter_text}})
        }

        const transformRubrics = rubricArticleStore.transformRubrics();

        //console.log(transformRubrics);

        return {
            transformRubrics,
            goToFilteredArticlePage
        }
    },
    components: {HeaderPage, FooterPage}
}
</script>

<style scoped>
.body_zone{
  background-color: #f8faff;
}

@media (max-width: 767px){
  .col-extra-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50% !important;
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
}

</style>